import * as React from 'react'
import { Text, Block } from '$views/components'
import { ServiceDetails } from '$domain/model/recommendation/recommendation.model'
import { CaredType, caredText } from '$domain/model/cared/cared'
import {
  ServiceColumn,
  StyledIcon,
} from '$views/PaymentDetails/OffSessionPayment/OffSessionCustomerPayment/OffSessionCustomerPayment.styles'
import { formatDateServiceViewMapper, formatIntervalServiceViewMapperDetails } from '$utils/dateFormatter'

const calendarIcon = require('$icons/calendar.svg')
const locationIcon = require('$icons/location.svg')
const heartIcon = require('$icons/heart.svg')

interface Props {
  service?: Partial<ServiceDetails>
  dates?: { date: Date; hours: { start: string; end: string }[] }[]
  address?: string
}

export const ServiceList: React.SFC<Props> = ({ service, dates, address }) => {
  const showHeartBlock = () => service && (service.age !== 0 || service.caredType !== 0)

  return (
    <ServiceColumn>
      <Block flex marginTop="mini" marginBottom="base">
        <StyledIcon content={calendarIcon} size="m" />
        {service && service.serviceDates.length > 0 && (
          <Block marginLeft="base">
            {service.serviceDates.map((date, index) => (
              <Block key={index}>
                <Text as="span" weight="medium" marginRight="mini">
                  {formatDateServiceViewMapper(date.startingDateTime)}
                </Text>
                <Text as="span">
                  {formatIntervalServiceViewMapperDetails(date.startingDateTime, date.finishingDateTime)}
                </Text>
              </Block>
            ))}
          </Block>
        )}
        {dates && dates.length > 0 && (
          <Block marginLeft="base">
            {dates.map((day, index) => (
              <div key={`day-${index}`}>
                {day.hours.map((hour, hourIndex) => (
                  <div key={`hour-${hourIndex}`}>
                    <Text as="span" weight="medium" marginRight="mini">
                      {formatDateServiceViewMapper(day.date)}
                    </Text>
                    <Text as="span">{`${hour.start}h - `}</Text>
                    <Text as="span">{`${hour.end}h`}</Text>
                  </div>
                ))}
              </div>
            ))}
          </Block>
        )}
      </Block>
      <Block flex marginBottom="base">
        <StyledIcon content={locationIcon} size="m" color="darkGrey" />
        {service && service.location && <Text marginLeft="base">{service.location}</Text>}
        {address && <Text marginLeft="base">{address}</Text>}
      </Block>
      {showHeartBlock() && (
        <Block flex marginBottom="mini">
          <StyledIcon content={heartIcon} size="m" />
          <Block marginLeft="base">
            {service.caredType !== 0 && (
              <Text as="span" weight="medium">
                {caredText[CaredType[service.caredType]]}
              </Text>
            )}
            {service.age !== 0 && (
              <>
                <Text as="span">{` ${service.age} `}</Text>
                <Text as="span"> años</Text>
              </>
            )}
          </Block>
        </Block>
      )}
    </ServiceColumn>
  )
}



// WEBPACK FOOTER //
// ./src/views/PaymentDetails/components/ServiceList/ServiceList.tsx